import { v4 as uuidv4 } from "uuid";
import { api } from "./api";

const SESSION_KEY = "govbidiq_session_id";

export function getSessionId() {
  try {
    let s = localStorage.getItem(SESSION_KEY);
    if (!s) {
      s = (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : uuidv4();
      localStorage.setItem(SESSION_KEY, s);
    }
    return s;
  } catch (_) {
    return "anon-" + Math.random().toString(36).slice(2);
  }
}

export async function track(event_type, extra = {}) {
  try {
    await api.post("/events", {
      event_type,
      session_id: getSessionId(),
      path: typeof window !== "undefined" ? window.location.pathname : "",
      ...extra,
    });
  } catch (_) {
    // Analytics must never break the UI
  }
}

export function trackCTA(cta_id, extra = {}) {
  return track("cta_click", { cta_id, ...extra });
}

export function trackPageView(path) {
  return track("page_view", { path: path || (typeof window !== "undefined" ? window.location.pathname : "") });
}
